(() => {
  'use strict';

  const STARK_IDS=new Set([27,28,29]);
  const STARK_HANDLES={27:'stark-varg-ex',28:'stark-varg-mx1-2',29:'stark-varg-sm'};
  const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;

  const productUrl=id=>{
    if(typeof window.ELEVENINE_PRODUCT_URL==='function')return window.ELEVENINE_PRODUCT_URL(id);
    const product=window.ELEVENINE_CATALOG?.byId?.(id);
    if(product&&typeof window.ELEVENINE_CATALOG?.productUrl==='function')return window.ELEVENINE_CATALOG.productUrl(product);
    return `/products/${STARK_HANDLES[id]||''}`;
  };

  /* Navegación final: Accesorios SUR-RON es opción principal y MTB 29 queda fuera. */
  document.querySelectorAll('a').forEach(link=>{
    let href='';
    try{href=decodeURIComponent(link.getAttribute('href')||'')}catch{href=link.getAttribute('href')||''}
    if(/MTB\s*29/i.test(link.textContent)||/Bicicletas MTB 29/i.test(href))link.remove();
  });

  const accessoriesHref='/?categoria=Accesorios%20SUR-RON#productos';
  document.querySelectorAll('.desktop-nav').forEach(nav=>{
    const exists=[...nav.children].some(item=>item.matches?.('a')&&/Accesorios SUR-RON/i.test(item.textContent));
    if(exists)return;
    const link=document.createElement('a');
    link.href=accessoriesHref;
    link.textContent='Accesorios SUR-RON';
    const firstGroup=nav.querySelector('.nav-group');
    nav.insertBefore(link,firstGroup||null);
  });
  document.querySelectorAll('.mobile-nav-links').forEach(nav=>{
    const exists=[...nav.children].some(item=>item.matches?.('a')&&/Accesorios SUR-RON/i.test(item.textContent));
    if(exists)return;
    const link=document.createElement('a');
    link.href=accessoriesHref;
    link.textContent='Accesorios SUR-RON';
    nav.insertBefore(link,nav.querySelector('details')||null);
  });

  /* Envíos nacionales sin promesa de gratuidad. */
  document.querySelectorAll('#promo .ptrack span').forEach(span=>{
    span.textContent='🚚 Envío a todo México · 🛡️ Garantía de marca registrada · ⚡ Distribuidores oficiales · 💬 Asesoría el mismo día ·';
  });

  /* Los dos slogans ya existen en el DOM; sólo cambia su opacidad. */
  const heroTitle=document.querySelector('#hero .hero-copy h1');
  if(heroTitle){
    const slogans=[
      'ELEVENINE: productos diseñados por Riders para Riders.',
      'Porque solo un rider sabe lo que otro rider necesita.'
    ];
    heroTitle.classList.add('hero-slogan-title');
    heroTitle.setAttribute('aria-live','polite');
    heroTitle.innerHTML=slogans.map((slogan,index)=>`<span class="hero-slogan-text ${index===0?'is-active':''}">${slogan}</span>`).join('');
    if(!reduceMotion){
      let sloganIndex=0;
      window.setInterval(()=>{
        const texts=heroTitle.querySelectorAll('.hero-slogan-text');
        texts[sloganIndex]?.classList.remove('is-active');
        sloganIndex=(sloganIndex+1)%texts.length;
        texts[sloganIndex]?.classList.add('is-active');
      },5200);
    }
  }

  const actionMarkup=id=>`<a class="stark-product-action" href="${productUrl(id)}">VER PRODUCTO</a>`;
  const customizeStarkCards=(root=document)=>{
    STARK_IDS.forEach(id=>{
      root.querySelectorAll?.(`[data-product-id="${id}"]`).forEach(card=>{
        card.classList.add('is-stark-quote-card');
        card.querySelectorAll('.pr').forEach(price=>price.remove());
        const actions=card.querySelector('.acts');
        if(actions&&!actions.querySelector('.stark-product-action'))actions.innerHTML=actionMarkup(id);
      });
    });
  };
  customizeStarkCards();

  /* El destacado y los listados abren la ficha; WhatsApp vive sólo en el single. */
  const featured=document.getElementById('destacado');
  if(featured){
    featured.querySelector('.price-tag')?.remove();
    const actions=featured.querySelector('.hero-ctas');
    if(actions)actions.innerHTML=actionMarkup(27);
  }

  const patchComparator=()=>{
    const active=document.querySelector('.comp-tabs button.on');
    if(active?.dataset.brand!=='stark')return;
    const rows=[...document.querySelectorAll('#compTable tbody tr')];
    rows.find(row=>row.firstElementChild?.textContent.trim()==='Precio')?.remove();
    const actionRow=rows.at(-1);
    if(actionRow){
      [...actionRow.children].slice(1).forEach((cell,index)=>{
        const id=[27,28,29][index];
        cell.innerHTML=actionMarkup(id);
      });
    }
  };
  document.querySelectorAll('.comp-tabs button').forEach(button=>button.addEventListener('click',()=>queueMicrotask(patchComparator)));
  patchComparator();

  [document.getElementById('shopGrid'),document.getElementById('starkGrid')].filter(Boolean).forEach(grid=>{
    new MutationObserver(()=>customizeStarkCards(grid)).observe(grid,{childList:true,subtree:true});
  });

  /* Posters locales: evitan cuadros negros mientras cargan los videos de Shopify Files. */
  const basename=url=>{
    try{return decodeURIComponent(String(url||'').split('/').pop().split(/[?#]/)[0])}catch{return String(url||'').split('/').pop().split(/[?#]/)[0]}
  };
  const posterFor=video=>{
    const source=video.querySelector('source')?.getAttribute('src')||video.getAttribute('src')||'';
    return window.ELEVENINE_VIDEO_POSTERS?.[basename(source)]||'';
  };
  const videoObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(entry=>{
    const video=entry.target;
    if(entry.isIntersecting&&!document.hidden&&!reduceMotion)video.play().catch(()=>{});
    else video.pause();
  }),{rootMargin:'220px 0px',threshold:.04}):null;
  const enhanceVideos=(root=document)=>root.querySelectorAll?.('video[data-product-video]:not([data-final-video-ready])').forEach(video=>{
    video.dataset.finalVideoReady='true';
    video.muted=true;
    video.defaultMuted=true;
    video.loop=true;
    video.playsInline=true;
    video.preload='metadata';
    const poster=posterFor(video);
    if(poster)video.setAttribute('poster',poster);
    if(video.readyState===0)video.load();
    if(videoObserver)videoObserver.observe(video);
    else if(!reduceMotion)video.play().catch(()=>{});
  });
  enhanceVideos();
  new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{
    if(node.nodeType!==1)return;
    enhanceVideos(node.matches?.('video[data-product-video]')?node.parentElement:node);
    customizeStarkCards(node);
  }))).observe(document.body,{childList:true,subtree:true});

  const bestSection=document.getElementById('productos');
  const requested=window.ELEVENINE_COLLECTION_CATEGORY||new URLSearchParams(location.search).get('categoria');
  if(bestSection&&!requested){
    const subtitle=bestSection.querySelector('.sec-sub');
    if(subtitle)subtitle.textContent='Cuatro esenciales de la comunidad ELEVENINE: SUR-RON, STARK VARG, goggles y cascos con video, variantes e información de cada producto.';
  }
})();
